import renderMinxs from "./render-mixin";
import { MODE } from './constant';

export const FlowContainerForRender = renderMinxs({
    mode: MODE.FLOW,
});

export const FreeContainerForRender = renderMinxs({
    mode: MODE.FREE,
});



// WEBPACK FOOTER //
// ./src/sdk/container/render.js